import { StreamingStatusDTO } from './StreamingStatus';
import {
  StreamingStatusWebService,
  RestfulStreamingStatusWebService
} from 'ws/StreamingStatusWebService';

export interface StreamingStatusManager {
  getStreamingStatusList(): Promise<StreamingStatusDTO[]>;
  updateStreamingStatus(crid: number | '', isLive: boolean): Promise<void>;
}

export class DefaultStreamingStatusManager implements StreamingStatusManager {
  constructor(
    private webService: StreamingStatusWebService = new RestfulStreamingStatusWebService()
  ) {}

  async getStreamingStatusList() {
    return this.webService.getStreamingStatusList();
  }

  async updateStreamingStatus(crid: number | '', isLive: boolean) {
    return this.webService.updateStreamingStatus(crid, isLive);
  }
}
